import { render } from "./GeralSidebar.vue?vue&type=template&id=260d7cb6&scoped=true"
import script from "./GeralSidebar.vue?vue&type=script&lang=js"
export * from "./GeralSidebar.vue?vue&type=script&lang=js"

import "./GeralSidebar.vue?vue&type=style&index=0&id=260d7cb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260d7cb6"]])

export default __exports__